export default __webpack_public_path__ + "static/media/CompanyIcon.902454cb.svg";